/**
 * StampCard - 교육과정 카드 컴포넌트
 *
 * 각 교육과정(스탬프)을 카드 형태로 표시
 * AI 테스트 버튼에 추출된 문제 수를 표시
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../common';
import { Lightbulb, BookOpenCheck, Trash2 } from 'lucide-react';

function StampCard({
  stamp,
  studentId,
  problemCount,
  onAITestClick,
  onDelete
}) {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/student/${studentId}/stamp/${stamp.stamp_id}/result`);
  };

  const handleWrongAnswerClick = (e) => {
    e.stopPropagation();
    navigate(`/student/${studentId}/stamp/${stamp.stamp_id}/wronganswer`);
  };

  return (
    <div
      className="border border-gray-200 rounded-3xl p-4 transition-all duration-300
                 shadow-lg hover:shadow-2xl hover:scale-[1.02] hover:border-primary/20
                 w-full"
    >
      <div className="flex justify-between items-center">
        {/* 좌측: 스탬프 정보 */}
        <div
          className="flex-1 min-w-0 cursor-pointer"
          onClick={handleCardClick}
        >
          <h3 className="font-semibold text-gray-900 truncate">{stamp.tree_name}</h3>
          <p className="text-sm text-gray-600 mt-1">교육과정: {stamp.edu_ver}</p>
          <p className="text-sm text-gray-600">테스트 횟수: <span className="font-bold text-primary">{stamp.exam_count}</span>회</p>
        </div>

        {/* 우측: 액션 버튼 */}
        <div className="flex flex-wrap items-center gap-2 ml-4 shrink-0">
        {/* AI 테스트 버튼 */}
        <Button
          variant={problemCount > 0 ? 'primary' : 'secondary'}
          size="sm"
          rounded="3xl"
          disabled={problemCount === 0}
          onClick={(e) => {
            e.stopPropagation();
            onAITestClick(stamp);
          }}
          className="flex items-center gap-1"
        >
          <Lightbulb className="w-4 h-4" />
          AI ({problemCount})
        </Button>

        {/* 오답노트 버튼 */}
        <Button
          variant="secondary"
          size="sm"
          rounded="3xl"
          onClick={handleWrongAnswerClick}
          className="flex items-center gap-1"
        >
          <BookOpenCheck className="w-4 h-4" />
          오답노트
        </Button>

        {/* 삭제 버튼 (시험 없는 경우만) */}
        {stamp.exam_count === 0 && (
          <Button
            variant="danger"
            size="sm"
            rounded="3xl"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(stamp.stamp_id, stamp.exam_count);
            }}
            className="flex items-center gap-1"
          >
            <Trash2 className="w-4 h-4" />
            삭제
          </Button>
        )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(StampCard);
